import { SexualPositionChildOptionValueEnum, OutputSortTypeEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreAdultsOnly } from '@types';

const initialState: IStoreAdultsOnly = {
  isIncludeUsed: true,
  isIncludeOtherUsersUsed: true,
  sortType: OutputSortTypeEnum.RANDOM,
  sexualPosition: SexualPositionChildOptionValueEnum['정상위'],
  characterNumber: null,
  femaleBody: null,
  sexualBodyPart: null,
  frame: null,
  angleFirst: null,
  angleSecond: null,
  selectedMetaTags: []
};

export const adultsOnlySlice = createSlice({
  name: 'adultsOnly',
  initialState,
  reducers: {
    initAdultsOnly: () => {
      return initialState;
    },

    setAdultsOnly: (state, action: PayloadAction<Partial<IStoreAdultsOnly>>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initAdultsOnly, setAdultsOnly } = adultsOnlySlice.actions;

export default adultsOnlySlice.reducer;
